<template>
  <vs-row vs-type="flex" vs-w="12" id="productCategoryPage">
    <new-category-add ref="newCategoryAdd" @saveChanges="saveNewCategory" />
    <new-product-add-to-category ref="newProductAddToCategory" @saveChanges="saveNewProduct" />
    <vs-popup class="holamundo" title="Kategori Sil" v-esc="escapeDeleteCategory" :active.sync="deleteCategoryActive">
      <vs-row vs-type="flex" vs-w="12" v-if="toRemoveCategory != null">
        <span>{{toRemoveCategory.name}} Kategorisini Silmek İstediğinize Eminmisiniz ? </span>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deleteCategoryActive = false;">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
          @click="toRemoveCategory.rootCategoryId == null ? removeCategory(true) : removeCategory(false)">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-popup class="holamundo" title="Ürün Sil" v-show="deleteProductPopupActive && selectedProducts.length > 0"
      v-esc="escapeDeleteProducts" :active.sync="deleteProductPopupActive">
      <vs-row vs-type="flex" vs-w="12">
        <span>Seçili Ürünleri({{selectedProducts.length}}) Çıkarmak İstediğinize Eminmisiniz ? </span>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deleteProductPopupActive = false;">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteListFromCategory">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-row vs-type="flex" vs-w="12" id="categoryList">
      <div class="w-auto d-flex" id="productActionBar">
        <vx-tooltip v-if="$isCenterBranch() || $isRegionalCenterBranch()"
          :text="(categoryBreadCrumbs.length > 0 ? categoryBreadCrumbs[categoryBreadCrumbs.length-1].name : 'Ana') + ' Kategoriye Alt Kategori Ekle'"
          position="top" class="mr-2">
          <vs-button
            @click="categoryBreadCrumbs.length > 0 ? addNewSubCategory(categoryBreadCrumbs[categoryBreadCrumbs.length-1]) : addNewCategory()"
            class="panel-action text-success large-button panel-action-box-shadow" color="transparent"
            icon-pack="feather" icon="icon-plus">
          </vs-button>
        </vx-tooltip>
        <vx-tooltip v-if="categoryBreadCrumbs.length > 0 && ($isCenterBranch() || $isRegionalCenterBranch())"
          :text="categoryBreadCrumbs[categoryBreadCrumbs.length-1].name + ' Kategorisini Sil'" position="top">
          <vs-button
            @click="toRemoveCategory = categoryBreadCrumbs[categoryBreadCrumbs.length-1];deleteCategoryActive = true;"
            class="panel-action text-danger large-button panel-action-box-shadow" color="transparent"
            icon-pack="feather" icon="icon-trash-2">
          </vs-button>
        </vx-tooltip>
      </div>
      <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center" class="mb-4">
        <div class="d-flex w-auto bg-white py-3 px-4 sale-box-shadow low-border-radius">
          <div class="d-flex w-auto pointer align-center" @click="clearBreadCrumb">
            <vs-button :disabled="categoryBreadCrumbs.length == 0" @click="getBackCategory" icon-pack="feather"
              icon="icon-arrow-left" color="primary" class="mr-4" />
            <span class="text-small passiveCategory">
              Kategoriler
            </span>
            <span v-if="categoryBreadCrumbs.length > 0" class="mx-2 text-medium-small passiveCategory">
              -
            </span>
          </div>
          <div class="d-flex w-auto align-center" v-for="(breadCrumb,index) in categoryBreadCrumbs"
            :key="breadCrumb.id">
            <span class="text-small activeCategory">
              {{breadCrumb.name}}
            </span>
            <span v-if="index != categoryBreadCrumbs.length-1" class="mx-2 text-medium-small passiveCategory">
              -
            </span>
          </div>
        </div>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-2" vs-justify="center" v-if="categoryDataList == null">
        <span class="text-secondary text-small weight-600">
          Hiçbir Kategori Bulunmamaktadır !
        </span>
      </vs-row>
      <vs-row v-else vs-type="flex" vs-w="12" class="px-6" vs-justify="center" vs-align="center">
        <vs-col vs-type="block" :vs-w="columnSize" class="productCategory text-center px-4"
          v-for="(category) in categoryDataList" :key="category.id">
          <div class="w-auto pointer" @click="selectCategory(category)"
            :class="{'low-opacity' : selectedCategory != null && (category.id != selectedCategory.id)}">
            <div class="w-full justify-center text-center mx-auto">
              <img class="responsive" :src="getImage(category.imageUrl)" />
            </div>
            <span v-if="selectedCategory == null || (category.id != selectedCategory.id)"
              class="productCategoryLabel block text-center w-full text-primary weight-600 text-xsmall">
              {{category.name}}
            </span>
          </div>
          <div v-if="selectedCategory != null && (category.id == selectedCategory.id)" class="categoryMask">
            <div class="w-full h-full" style="position:relative;">
              <vs-button v-if="$isCenterBranch() || $isRegionalCenterBranch()" @click="editCategory(selectedCategory)" color="white" icon-pack="feather" icon="icon-settings"
                class="responsive sale-box-shadow categorySettingsButton" />
              <vs-button @click="goInsideCategory(selectedCategory)" v-if="category.childCategories != null"
                icon="icon-log-in" icon-pack="feather" color="transparent" class="text-white categoryDetailButton" />
              <span class="productCategoryLabel px-5 block w-full text-white bold text-xsmall">
                {{category.name}}
              </span>
              <div class="categoryActionButtons block">
                <vs-button @click="addNewSubCategory(selectedCategory)" v-if="selectedCategory.products == null && ($isCenterBranch() || $isRegionalCenterBranch())"
                  color="white" icon-pack="feather" icon="icon-plus" radius class="responsive mb-2 sale-box-shadow" />
                <vs-button v-if="$isCenterBranch() || $isRegionalCenterBranch()" @click="toRemoveCategory = category;deleteCategoryActive = true;" color="white"
                  icon-pack="feather" icon="icon-trash-2" radius class="responsive mt-2 sale-box-shadow" />
                <vs-button color="white" icon-pack="feather" icon="icon-rotate-ccw" radius
                  class="responsive mt-2 sale-box-shadow" @click="selectedCategory = null" />
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="categoryPageList" class="my-4">
      <pagination-default :totalLenght="totalCategoryPageSize" :setCurrentPage="categoryPage"
        @currentPage="getCurrentPage"></pagination-default>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="productList" v-if="selectedCategory != null" class="mt-2">
      <div v-if="selectedCategory.childCategories == null" class="w-auto d-flex" id="productActionBar">
        <vx-tooltip v-if="$isCenterBranch() || $isRegionalCenterBranch()" :text="selectedCategory.name + ' Kategorisine Ürün Ata'" position="top" class="mr-2">
          <vs-button @click="addNewProduct" class="panel-action text-success large-button panel-action-box-shadow"
            color="transparent" icon-pack="feather" icon="icon-plus">
          </vs-button>
        </vx-tooltip>
        <vx-tooltip v-if="this.selectedProducts.length > 0 && ($isCenterBranch() || $isRegionalCenterBranch())"
          :text="selectedCategory.name + ' Kategorisinden Ürünleri Çıkar'" position="top">
          <vs-button @click="deleteProductPopupActive = true;"
            class="panel-action text-danger large-button panel-action-box-shadow" color="transparent"
            icon-pack="feather" icon="icon-minus">
          </vs-button>
        </vx-tooltip>
      </div>
      <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
        <div class="d-flex w-auto bg-white py-3 px-4 sale-box-shadow low-border-radius">
          <span class="text-small passiveCategory">
            {{selectedCategory.name}}
          </span>
        </div>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="px-6" vs-align="center">
          <span v-if="productDataList == null" class="mt-2 text-secondary text-small weight-600">
            Bu Kategoride Ürün Bulunmamaktadır !
          </span>
          <vs-col v-else vs-type="block" :vs-w="columnSize-0.07" class="text-center px-4 mx-1 low-border-radius"
            :class="{'sale-box-shadow' : isSelectedProduct(product.id)}" v-for="product in productDataList"
            :key="product.id">
            <div class="w-auto pointer productCategoryProduct" @click="productClicked(product.id)">
              <div class="w-full justify-center text-center mx-auto">
                <img class="responsive" :src="getImage(product.imageUrl)" />
              </div>
              <span class="productCategoryLabel block text-center w-full text-primary weight-600 text-xsmall">
                {{product.name}}
              </span>
              <feather-icon v-if="isSelectedProduct(product.id)" icon='CheckCircleIcon' svgClasses='text-primary' />
            </div>
          </vs-col>
        </vs-row>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <pagination-default :totalLenght="totalProductPageSize" :setCurrentPage="productPage"
          @currentPage="getCurrentProductPage"></pagination-default>
      </vs-row>
    </vs-row>
  </vs-row>
</template>

<script>
  import NewProductAddToCategory from "./NewProductAddToCategory.vue";
  import NewCategoryAdd from "./NewCategoryAdd.vue";
  import PaginationDefault from "../PaginationDefault"
  import {
    getProductCategories,
    getCategoryDetail,
    deleteListFromCategory,
    deleteProductCategory
  } from "@/api/ProductCategory";
  import GlobalFilter from "../GlobalFilter";
  import {isGranted} from "@/utils/auth";
  export default {
    data() {
      return {
        categories: null,
        columnSize: 0,
        maxColumnCount: 0,
        categoryPage: 0,
        productPage: 0,
        selectedCategory: null,
        selectedProducts: [],
        categoryBreadCrumbs: [],
        productBreadCrumbs: [],
        canForward: true,
        deleteProductPopupActive: false,
        toRemoveCategory: null,
        deleteCategoryActive: null
      }
    },
    components: {
      GlobalFilter,
      PaginationDefault,
      NewCategoryAdd,
      NewProductAddToCategory
    },
    computed: {
      totalCategoryPageSize() {
        if (this.categoryDataList == null) return 0;
        else {
          let list = this.categoryBreadCrumbs.length > 0 ? this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 1]
            .childCategories :
            this.categories;
          return Math.ceil(list.length / this.maxColumnCount);
        }
      },
      totalProductPageSize() {
        if (this.productDataList == null) return 0;
        else {
          return Math.ceil(this.selectedCategory.products.length / this.maxColumnCount);
        }
      },
      categoryDataList() {
        let list = this.categoryBreadCrumbs.length > 0 ? this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 1]
          .childCategories : this.categories;
        if (list == null) return null;
        else {
          let startIndex = this.categoryPage * this.maxColumnCount;
          if (list.length - startIndex > this.maxColumnCount) {
            return list.slice(startIndex, startIndex + this.maxColumnCount);
          } else {
            return list.slice(startIndex);
          }
        }
      },
      productDataList() {
        let startIndex = this.productPage * this.maxColumnCount;
        let list = this.selectedCategory.products;
        if (list == null) return null;
        if (list.length - startIndex > this.maxColumnCount)
          return list.slice(startIndex, startIndex + this.maxColumnCount);
        else return list.slice(startIndex);
      },
      isAddProductCategoryPermission(){
      return isGranted("product_category_write")
    },
    isDeleteProductCategoryPermission(){
      return isGranted("product_category_delete")
    }
    },
    methods: {
      saveNewProduct(){
        this.getCategoryDetail(this.selectedCategory);
      },
      getBackCategory() {
        this.categoryPage = 0;
        this.productPage = 0;
        this.categoryBreadCrumbs.splice(-1)
      },
      deleteListFromCategory() {
        if (this.selectedProducts.length <= 0) return;
        let obj = {
          categoryId: this.selectedCategory.id,
          productsIds: this.selectedProducts
        };
        deleteListFromCategory(obj).then(res => {
          if (res && res.status == 200) {
            this.selectedProducts.forEach(removed => {
              let index = this.selectedCategory.products.findIndex(x => x.id == removed);
              this.selectedCategory.products.splice(index, 1);
            });
            this.selectedProducts = [];
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı ! ',
              text: 'Seçilen Ürünler Çıkartıldı !'
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Seçilen Ürünler Çıkartılamadı !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      escapeDeleteCategory() {
        if (this.deleteCategoryActive == true) this.deleteCategoryActive = false;
      },
      escapeDeleteProducts() {
        if (this.deleteProductPopupActive == true) {
          this.deleteProductPopupActive = false;
          this.selectedProducts = [];
        }
      },
      goInsideCategory(category) {
        this.categoryPage = 0;
        this.productPage = 0;
        this.categoryBreadCrumbs.push(category);
        this.selectedCategory = null;
      },
      productClicked(id) {
        let selected = this.selectedProducts.findIndex(x => x == id);
        if (selected >= 0) this.selectedProducts.splice(selected, 1);
        else this.selectedProducts.push(id);
      },
      isSelectedProduct(id) {
        return this.selectedProducts.some(x => x == id);
      },
      getCurrentPage(currentx) {
        this.categoryPage = currentx - 1;
      },
      getCurrentProductPage(currentx) {
        this.productPage = currentx - 1;
      },
      clearBreadCrumb() {
        this.categoryBreadCrumbs = [];
        this.selectedCategory = null;
      },
      selectCategory(category) {
        this.getCategoryDetail(category);
      },
      editCategory(category) {
        if (this.categoryBreadCrumbs.length > 1) {
          let root = this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 2];
          this.$refs.newCategoryAdd.rootCategory = {
            id: root.id,
            name: root.name,
            childCategories: _.cloneDeep(root.childCategories)
          }
        } else {
          let root = this.categories;
          this.$refs.newCategoryAdd.rootCategory = {
            id: 0,
            name: "Ana Kategori",
            childCategories: _.cloneDeep(root)
          }
        }
        this.$refs.newCategoryAdd.isActive = true;
        this.$refs.newCategoryAdd.newCategory = category;
        let oldIndex = this.$refs.newCategoryAdd.rootCategory.childCategories.findIndex(x => x.id == category.id);
        this.$refs.newCategoryAdd.rootCategory.childCategories[oldIndex] = this.$refs.newCategoryAdd.newCategory
        //this.$refs.newCategoryAdd.rootCategory.categories.push(this.$refs.newCategoryAdd.newCategory);
      },
      addNewSubCategory(root) {
        this.$refs.newCategoryAdd.rootCategory = {
          id: root.id,
          name: root.name,
          childCategories: root.childCategories != null ? _.cloneDeep(root.childCategories) : [],
          rootCategoryId: root.rootCategoryId
        };
        this.$refs.newCategoryAdd.isActive = true;
        this.$refs.newCategoryAdd.newCategory = {
          id: null,
          imageUrl: null,
          index: 1,
          products: null,
          childCategories: null,
          rootCategoryId: root.id
        };
        this.$refs.newCategoryAdd.rootCategory.childCategories.push(this.$refs.newCategoryAdd.newCategory);
      },
      addNewCategory() {
        if (this.categoryBreadCrumbs.length > 1) {
          let root = this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 2];
          this.$refs.newCategoryAdd.rootCategory = {
            id: root.id,
            name: root.name,
            childCategories: _.cloneDeep(root.childCategories)
          }
        } else {
          let root = this.categories;
          this.$refs.newCategoryAdd.rootCategory = {
            id: 0,
            name: "Ana Kategori",
            childCategories: _.cloneDeep(root)
          }
        }
        this.$refs.newCategoryAdd.isActive = true;
        this.$refs.newCategoryAdd.newCategory = {
          id: null,
          imageUrl: null,
          index: 1,
          products: null,
          childCategories: null,
          rootCategoryId: this.categoryBreadCrumbs.length > 1 ? this.categoryBreadCrumbs[this.categoryBreadCrumbs
            .length - 2].id : null
        };
        this.$refs.newCategoryAdd.rootCategory.childCategories.push(this.$refs.newCategoryAdd.newCategory);
      },
      removeCategory(isRoot) {
        deleteProductCategory(this.toRemoveCategory.id).then(res => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı !',
              text: 'Kategori Başarıyla Silindi !'
            });
            this.selectedCategory = null;
            if (isRoot == true) this.getBackCategory();
            let dataList = this.categoryBreadCrumbs.length > 0 ? this.categoryBreadCrumbs[this.categoryBreadCrumbs
              .length - 1].childCategories : this.categories;
            let index = dataList.findIndex(x => x.id == this.toRemoveCategory.id);
            dataList.splice(index, 1);
            this.deleteCategoryActive = false;
            this.toRemoveCategory = null;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategori Silinemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      addNewProduct() {
        this.$refs.newProductAddToCategory.addNewProductActive = true;
        this.$refs.newProductAddToCategory.categoryId = this.selectedCategory.id;
      },
      saveNewCategory(root) {
        if (this.categoryBreadCrumbs.length > 1) {
          let oldRoot = this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 2];
          oldRoot = root.childCategories;
        } else {
          if (root.id != 0)
            this.goInsideCategory(root);
          else {
            this.categories = root.childCategories;
          }
        }
        this.selectedCategory = null;
      },
      getImage(image) {
        if (image == null) return this.$nullImage;
        else return this.$baseUrl + '/' + image;
      },
      getCategoryDetail(category) {
        getCategoryDetail(category.id).then(res => {
          if (res && res.status == 200) {
            if (res.data.products != null) {
              category.products = res.data.products;
              this.selectedCategory = category;
            } else if (res.data.childCategories != null) {
              category.childCategories = res.data.childCategories;
              this.selectedCategory = category;
            } else {
              this.selectedCategory = category;
            }
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategoriler Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      getProductCategories() {
        getProductCategories().then(res => {
          if (res && res.status == 200) {
            this.categories = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategoriler Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
    },
    created() {
      if (window.matchMedia("(min-height: 1000px)").matches) {
        this.columnSize = 1.2;
        this.maxColumnCount = 20;
      } else {
        if (window.matchMedia("(min-width: 900px)").matches) {
          this.columnSize = 1.7;
          this.maxColumnCount = 7;
        } else if (window.matchMedia("(min-width: 700px)").matches) {
          this.columnSize = 2.3;
          this.maxColumnCount = 5
        } else if (window.matchMedia("(min-width: 500px)").matches) {
          this.columnSize = 3;
          this.maxColumnCount = 4;
        } else if (window.matchMedia("(min-width: 350px)").matches) {
          this.columnSize = 3.5;
          this.maxColumnCount = 6;
        }
      }
      this.categoryPage = 0;
      this.productPage = 0;
      this.getProductCategories();
    }
  }

</script>

<style>
  #productCategoryPage {
    overflow: hidden;
  }

  .activeCategory {
    color: rgba(var(--vs-dark), 1);
    font-weight: 500;

  }

  .passiveCategory {
    color: rgba(var(--vs-primary), 1);
    font-weight: bold;
  }

  .categoryPager {
    height: 100% !important;
    width: 25px;
  }

  .categoryPager i {
    color: rgba(var(--vs-primary), 1);
    font-weight: bold;
    font-size: 24px;
  }

  #categoryListCol {
    width: calc(100% - 76px) !important;
  }

  #categoryList {
    position: relative;
  }

  #productListCol {
    width: calc(100% - 76px) !important;
  }

  #productList {
    position: relative;
  }

  #productActionBar {
    position: absolute;
    left: 0;
    top: 0;
  }

  .productCategoryLabel {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .categoryMask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    left: 0;
    top: 0;
    border: solid 1px #000000;
    border-radius: 7px;
    border-top-right-radius: 0;
  }

  .productCategory {
    position: relative;
  }

  .productCategoryProduct {
    position: relative;
  }

  .productCategoryProduct svg {
    width: 35px;
    height: 35px;
  }

  .categoryMask .productCategoryLabel {
    position: absolute;
    top: 75%;
  }

  .categoryDetailButton {
    width: 60% !important;
    height: 60% !important;
    margin: auto;
  }

  .categoryDetailButton i {
    font-size: 300%;
  }

  .categoryMask .feather-icon {
    left: -1vw;
    top: 2vh;
  }

  .productCategoryProduct .feather-icon {
    top: 70%;
    left: 65%;
    position: absolute !important;
  }

  .categoryActionButtons2 {
    left: -22px !important;
  }

  .categoryActionButtons {
    height: 100%;
    width: auto;
    position: absolute;
    top: 0;
    left: -22px;
  }

  .categoryActionButtons .icon-plus {
    color: rgba(var(--vs-success), 1);
    font-weight: 600 !important;
  }

  .categoryActionButtons .icon-trash-2 {
    color: rgba(var(--vs-danger), 1);
    font-weight: 600 !important;
  }

  .categoryActionButtons .icon-rotate-ccw {
    color: rgba(var(--vs-dark), 1);
    font-weight: 600 !important;
  }

  .categorySettingsButton .icon-settings {
    color: rgba(var(--vs-white), 1);
    font-weight: 600 !important;
  }

  .low-opacity {
    opacity: 0.35;
  }

  .categorySettingsButton {
    top: -39px;
    left: calc(100% - 37px);
    background-color: rgba(0, 0, 0, .5) !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    position: absolute;
  }

</style>
